import { Model } from '@/models/Model'

export class NetworkInformationIsrses extends Model {
	protected jsonApiType = 'networkInformationIsrses'
}
